import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { anomalyLabel } from '../../utils/anomalyLabels';

// Puantaj motorunun ürettiği anomali kodlarını nötr gri rozetler olarak listeler. Plan 3 Task 2'de
// PuantajPage config'inde satır içi tanımlıydı; Eksik Kayıtlar sayfası da AYNI rozet listesini
// kullandığı için ortak bileşene çıkarıldı (tek kaynak — iki liste sayfası birebir aynı görünür).
// Rozetler durum rengi TAŞIMAZ (severity/renk kodlaması Plan 3'ün dışında).

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const Badge = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  background: #f3f4f6;
  color: #6b7280;
`;

export default function AnomalyBadges({ codes }) {
  const { t } = useTranslation();
  if (!codes || codes.length === 0) return '—';
  return (
    <List>
      {codes.map((code) => (
        <Badge key={code}>{anomalyLabel(t, code)}</Badge>
      ))}
    </List>
  );
}
